import { useFloating } from "./auth-service-tools430.js";
import "react";
import { useFloatingAutoUpdate } from "./auth-service-tools367.js";
import { useUncontrolled } from "./auth-service-tools323.js";
import { useDidUpdate } from "./auth-service-tools369.js";
import { offset, shift, limitShift, flip, inline, arrow, size } from "./auth-service-tools555.js";

function getDefaultMiddlewares(middlewares) {
  if (middlewares === void 0) {
    return {
      shift: true,
      flip: true
    };
  }

  const result = { ...middlewares
  };

  if (middlewares.shift === void 0) {
    result.shift = true;
  }

  if (middlewares.flip === void 0) {
    result.flip = true;
  }

  return result;
}

function getPopoverMiddlewares(options, getFloating) {
  const middlewaresOptions = getDefaultMiddlewares(options.middlewares);
  const middlewares = [offset(options.offset)];

  if (middlewaresOptions.shift) {
    middlewares.push(shift(typeof middlewaresOptions.shift === "boolean" ? {
      limiter: limitShift(),
      padding: 5
    } : {
      limiter: limitShift(),
      padding: 5,
      ...middlewaresOptions.shift
    }));
  }

  if (middlewaresOptions.flip) {
    middlewares.push(typeof middlewaresOptions.flip === "boolean" ? flip() : flip(middlewaresOptions.flip));
  }

  if (middlewaresOptions.inline) {
    middlewares.push(typeof middlewaresOptions.inline === "boolean" ? inline() : inline(middlewaresOptions.inline));
  }

  middlewares.push(arrow({
    element: options.arrowRef,
    padding: options.arrowOffset
  }));

  if (middlewaresOptions.size || options.width === "target") {
    middlewares.push(size({ ...(typeof middlewaresOptions.size === "boolean" ? {} : middlewaresOptions.size),

      apply(_ref) {
        let {
          rects,
          availableWidth,
          availableHeight,
          ...rest
        } = _ref;

        var _a, _b;

        const floating = getFloating();
        const styles = (_b = (_a = floating.refs.floating.current) == null ? void 0 : _a.style) != null ? _b : {};

        if (middlewaresOptions.size) {
          if (typeof middlewaresOptions.size === "object" && !!middlewaresOptions.size.apply) {
            middlewaresOptions.size.apply({
              rects,
              availableWidth,
              availableHeight,
              ...rest
            });
          } else {
            Object.assign(styles, {
              maxWidth: `${availableWidth}px`,
              maxHeight: `${availableHeight}px`
            });
          }
        }

        if (options.width === "target") {
          Object.assign(styles, {
            width: `${rects.reference.width}px`
          });
        }
      }

    }));
  }

  return middlewares;
}

function usePopover(options) {
  const [_opened, setOpened] = useUncontrolled({
    value: options.opened,
    defaultValue: options.defaultOpened,
    finalValue: false,
    onChange: options.onChange
  });

  const onClose = () => {
    if (_opened) {
      setOpened(false);
    }
  };

  const onToggle = () => setOpened(!_opened);

  const floating = useFloating({
    strategy: options.strategy,
    placement: options.position,
    middleware: getPopoverMiddlewares(options, () => floating)
  });
  useFloatingAutoUpdate({
    opened: _opened,
    position: options.position,
    positionDependencies: options.positionDependencies || [],
    floating
  });
  useDidUpdate(() => {
    var _a;

    (_a = options.onPositionChange) == null ? void 0 : _a.call(options, floating.placement);
  }, [floating.placement]);
  useDidUpdate(() => {
    var _a, _b;

    if (!_opened) {
      (_a = options.onClose) == null ? void 0 : _a.call(options);
    } else {
      (_b = options.onOpen) == null ? void 0 : _b.call(options);
    }
  }, [_opened, options.onClose, options.onOpen]);
  return {
    floating,
    controlled: typeof options.opened === "boolean",
    opened: _opened,
    onClose,
    onToggle
  };
}

export { usePopover };